<template>
  <div>
    <div class="title">
      我的信箱
    </div>
    <div class="main">
      <!-- 空数据状态 -->
      <van-empty v-if="showEmpty" description="还没有任何消息哦，快去发送一条吧">
        <van-button round type="danger" to="/write" class="bottom-button" color="#00D477">去发短信</van-button>

        <!-- 未绑定手机号 → 显示提示 + 登录按钮 -->
        <div v-if="!isBindPhone" class="login-tip">
          <span class="tip-text">找不到发送记录？登录试试</span>
          <van-button round type="success" class="bottom-button" color="#00D477" @click="showBindPhoneDialog = true">
            登录
          </van-button>
        </div>

      </van-empty>

      <!-- 有数据时显示列表 -->
      <van-swipe-cell
          v-for="(item, index) in chatData"
          :key="index"
          :before-close="(params) => deleteMsg(params, item.id,item.smsStatus)"
      >
        <MailboxItem
            :date="item.sendTime"
            :phone="item.phone"
            :replyCount="item.replyCount"
            :smsStatus="item.smsStatus"
            @click="toChat(index)"
            :content="item.content"
        />
        <template #right>
          <van-button square text="删除" type="danger" class="delete-button" />
        </template>
      </van-swipe-cell>
    </div>

    <BindPhoneDialog
        v-model:show="showBindPhoneDialog"
        :dialog-title="'登录'"
        :show-tips="false"
        @bind-success="handleBindSuccess"
        @close="handleBindClose"
    />
  </div>
</template>

<script>
import { getUserInfo } from "@/api/user";
import { Button, Empty, SwipeCell, Dialog, Toast } from 'vant';
import MailboxItem from "../../components/mailbox/MailboxItem";
import { getMailBoxList, deleteSms } from "../../api/sms";
import BindPhoneDialog from '@/components/BindPhoneDialog.vue';

export default {
  name: "mailbox",
  data() {
    return {
      clientHeight: '',
      showEmpty: false,
      showBindPhoneDialog: false,
      isBindPhone: true,
      chatData: []
    }
  },
  components: {
    [Button.name]: Button,
    [Empty.name]: Empty,
    [SwipeCell.name]: SwipeCell,
    [Dialog.Component.name]: Dialog.Component,
    BindPhoneDialog,
    MailboxItem
  },
  created() {
    this.getList();
    getUserInfo().then(res => {
      if (res.data.code === '00000') {
        this.isBindPhone = !!(res.data.data.phone);
      }
    })
  },
  methods: {
    getList() {
      getMailBoxList().then(res => {
        this.chatData = res.data.data || [];
        this.showEmpty = this.chatData.length === 0;
      })
    },
    toChat(index) {
      this.$router.push({
        path: '/chat',
        query: {
          id: this.chatData[index].chatId,
          phone: this.chatData[index].phone,
        }
      })
    },
    deleteMsg(params, id, smsStatus) {
      if (params.position === 'right') {
        return new Promise((resolve) => {
          resolve(true);
          let title = '确定删除吗？'
          if (smsStatus === 1) {
            title = '删除后信息将会取消发送且不退款，确定删除吗？'
          }
          Dialog.confirm({ message: title }).then(() => {
            deleteSms(id).then(res => {
              if (res.data.data) {
                Toast.success("删除成功");
                this.getList();
              } else {
                Toast.fail("删除失败");
              }
            })
          }).catch(() => {});
        });
      }
    },
    handleBindSuccess() {
      this.isBindPhone = true;
      this.showBindPhoneDialog = false;
      this.getList(); // 登录成功后重新获取列表
    },
    handleBindClose() {
      this.showBindPhoneDialog = false;
    }
  }
}
</script>

<style scoped>
.main {
  background: #f7f7f7;
  padding: 0 15px 65px 15px;
  height: 100%;
  box-sizing: border-box;
}
.delete-button {
  height: 100%;
}
.title {
  font-size: 22px;
  color: #292833;
  font-weight: bold;
  height: 40px;
  padding: 15px;
  line-height: 40px;
  z-index: 999;
  background: #f7f7f7;
  position: sticky;
  top: 0;
}
.bottom-button {
  width: 160px;
  height: 40px;
  margin-top: 10px;
}

/* 登录提示样式 */
.login-tip {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tip-text {
  font-size: 14px;
  color: #999;
  margin-bottom: 10px;
}
</style>